import api from "@/api/viktor"

export async function getPoleEmploiSynthesis(uuid: string) {
  const response = await api({
    method: "get",
    url: `/user/${uuid}/synthesis-pole-emploi`,
  })

  return response
}
